import { Industry } from "@utils/typescript/model/industry/industry.ts";
import { tryCatch } from "@utils/typescript/try-catch.ts";

// INDUSTRY FIELD SELECTOR
async function handleIndustryFieldSelector() {
  const industryFields: NodeListOf<HTMLSelectElement> =
    document.querySelectorAll('select[name="b2b_industryName"]'); // Currently only used for B2B new registration form

  if (industryFields.length === 0) return;

  // Get first found tenant and clientLocale from the first industry field. We need the tenant for the request. But we don't want to make the request for every field in the iteration.
  const tenant = industryFields[0]?.getAttribute("data-tenant");
  const clientLocale = industryFields[0]?.getAttribute("data-client-locale");

  // Error handling for missing tenant or clientLocale
  if (!tenant)
    return console.error("Error: Missing tenant attribute on industry field");
  if (!clientLocale)
    return console.error(
      "Error: Missing client-locale attribute on industry field",
    );

  const result = await getAvailableIndustryCodes(tenant, clientLocale);
  if (result.error || !result.data.ok) {
    industryFields.forEach((industryField) => {
      industryField.innerHTML = `<option value="Fallback" disabled selected>Error loading industry codes, using fallback</option>`;
      industryField.disabled = true;
    });

    return console.error(
      "Error loading industry codes:",
      result.error,
      result.data?.statusText,
    );
  }

  const industryCodes: Array<Industry> = await result.data?.json();
  if (!industryCodes)
    return console.error("Error: No industry codes data available");

  industryFields.forEach((industryField) => {
    const countryEntries = industryCodes.map(
      (code) =>
        `<option
        value="${code.name}"
        data-industry-ssi-code="${code.ssiCode}"
        data-industry-nace-code="${code.naceCode}">
        ${code.name}
      </option>`,
    );

    // Add a default unselected option if specified (the first not selectable line in the select)
    const unselectedText = industryField.getAttribute("data-unselected-text");
    if (unselectedText) {
      countryEntries.unshift(
        `<option value="" disabled selected>${unselectedText}</option>`,
      );
    }

    industryField.innerHTML = countryEntries.join("");
  });

  // HELPER
  async function getAvailableIndustryCodes(
    tenant: string,
    clientLocale: string,
  ) {
    return await tryCatch(
      fetch(`/tenant/industry-codes/codes/${tenant}/${clientLocale}`),
    );
  }
}
handleIndustryFieldSelector();
